// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

function modifyMonth(el,add,nextWeek){
	let currentTarget = el.dataset.date.split('-');
	let dateConvert = new Date(currentTarget[1],parseInt(currentTarget[0]) - 1, 1);
	nextWeek.innerHTML = dateConvert.toLocaleString('default', { month: 'long' }) + ', ' + dateConvert.getFullYear();
	if(add){
		dateConvert.setMonth(dateConvert.getMonth() + 1);
	} else {
		dateConvert.setMonth(dateConvert.getMonth() - 1);
	}

	let finalMonth = (dateConvert.getMonth() + 1)  < 10 ? '0' + (dateConvert.getMonth() + 1) : (dateConvert.getMonth() + 1) ;
	el.dataset.date = finalMonth + '-' +dateConvert.getFullYear();
	
}

function modifyDate(date, days, add) {
	let newDate;

	if (add) {
		newDate = new Date(date.getTime() + days * (24 * 60 * 60 * 1000));
	} else {
		newDate = new Date(date.getTime() - days * (24 * 60 * 60 * 1000));
	}

	let month = parseInt(newDate.getMonth()) + 1 < 10 ? '0' + (newDate.getMonth() + 1) : newDate.getMonth() + 1;
	let day = parseInt(newDate.getDate()) < 10 ? '0' + newDate.getDate() : newDate.getDate();

	return newDate.getFullYear() + '/' + month + '/' + day;
}
function setSibling(prev,next,week) {
	let weekHTML = '';
	let minDate = prev.dataset.min.split('/');
	let minDateConverted = new Date(minDate[0],parseInt(minDate[1]) - 1,minDate[2]);
	let maxDate = next.dataset.max.split('/');
	let maxDateConverted = new Date(maxDate[0],parseInt(maxDate[1]) - 1,maxDate[2]);

	if(minDate[1] === maxDate[1]){
		weekHTML = minDateConverted.toLocaleString('default', { month: 'long' }) + ' ' + minDate[2] + ' - ' + maxDate[2] + ', ' + minDate[0];
	} else {
		weekHTML = minDateConverted.toLocaleString('default', { month: 'long' }) + ' ' + minDate[2] + (minDate[0] === maxDate[0] ? '':', ' + minDate[0]) + ' - ' + maxDateConverted.toLocaleString('default', { month: 'long' }) + ' ' + maxDate[2] + ', ' + maxDate[0];
	}
	week.innerHTML = weekHTML;
}
function setRealDate(currentDate) {
	let newDate = new Date(currentDate);
	newDate.setHours(0, 0, 0, 0);
	return newDate;
}


(function(){

    $(document).ready(function () {

        // Main Nav Dropdown
        $("#primary-nav li").hover(function(){
            $(this).addClass("hover");
            $('ul.submenu',this).fadeIn(200);
        }, function(){
            $(this).removeClass("hover");
            $('ul.submenu',this).fadeOut(200);
        });

    });

    window.onload = function() {
		if(!document.getElementById('gallery-flex')){
			scrollDownAction(60, 'scroll');
		}

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})

		if( document.querySelectorAll('.map-interactive') && window.innerWidth < 640){
			interactiveMapMobile();
		}
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	if(document.querySelector('.suites__tabs .tab')){
		document.addEventListener('DOMContentLoaded', function() {
			var triggers = document.querySelectorAll('.tab');
			var targets = document.querySelectorAll('.suites__item');

			if (triggers && targets.length > 0) {
				triggers[0].classList.add('active');
				targets[0].classList.add('active');
			
				triggers.forEach(function(trigger) {
					trigger.addEventListener('click', function() {
						var clickedTag = this.getAttribute('data-tag');
		
						triggers.forEach(function(item) {
							item.classList.remove('active');
						});
						
						targets.forEach(function(target) {
							var targetTag = target.getAttribute('data-tag');
							
							if (clickedTag === targetTag) {
								target.classList.add('active');
							} else {
								target.classList.remove('active');
							}
						});
		
						this.classList.add('active');
					});
				});
			}
		});
	}

	if(document.querySelector('.dining-quad__item')){
		var triggers = document.querySelectorAll('.tab');
		var targets = document.querySelectorAll('.dining-quad__item');

		if (triggers && targets.length > 0) {
			triggers[0].classList.add('active');
			targets[0].classList.add('active');
		
			triggers.forEach(function(trigger) {
				trigger.addEventListener('click', function() {
					var clickedTag = this.getAttribute('data-tag');

					triggers.forEach(function(item) {
						item.classList.remove('active');
					});
					
					targets.forEach(function(target) {
						var targetTag = target.getAttribute('data-tag');
						
						if (clickedTag === targetTag) {
							target.classList.add('active');
						} else {
							target.classList.remove('active');
						}
					});

					this.classList.add('active');
				});
			});
		}
	}

	document.addEventListener('DOMContentLoaded', function() {
		var elements = document.querySelectorAll('[data-fancybox="accommodations"]');

		elements.forEach(function(element) {
			if (!element.hasAttribute('data-lbx-group')) {
				element.setAttribute('data-lbx-group', 'accommodations');
			}
			if (!element.hasAttribute('data-lbx-full')) {
				element.setAttribute('data-lbx-full', '');
			}
		});
	});

	if (document.getElementsByClassName('js-date-prev').length > 0) {
		document.querySelectorAll('.js-date-prev').forEach((prev) => {
			let nextWeek = prev.nextElementSibling;
			let nextPrev = nextWeek.nextElementSibling;
			prev.addEventListener('click', function () {
				let currentDate = prev.getAttribute('data-min');
				if(prev.dataset.limit !== prev.dataset.min){
					let newDate = setRealDate(currentDate);
					let newMin = modifyDate(newDate, 7, false);
					let newMax = modifyDate(newDate, 1, false);

					nextPrev.dataset.max = newMax;
					prev.dataset.min = newMin;
					setSibling(prev,nextPrev,nextWeek);
					getEvents(newMin);

					
				}
				
			});
		});
		document.querySelectorAll('.js-date-next').forEach((next) => {
			let nextWeek = next.previousElementSibling;
			let prevNext = nextWeek.previousElementSibling;
			next.addEventListener('click', function () {
				let currentDate = next.getAttribute('data-max');
				let newDate = setRealDate(currentDate);
				let newMax = modifyDate(newDate, 7, true);
				let newMin = modifyDate(newDate, 1, true);

				prevNext.dataset.min = newMin;
				next.dataset.max = newMax;

				setSibling(prevNext,next,nextWeek);

				getEvents(newMin);
			});
		});
	}
	if(document.getElementsByClassName('js-month-prev').length > 0){
		document.querySelectorAll('.js-month-prev').forEach(prev => {
			let nextWeek = prev.nextElementSibling;
			let nextPrev = nextWeek.nextElementSibling;
			prev.addEventListener('click', function () {
				let targetMonth = prev.dataset.date;
				if(prev.dataset.limit !== nextWeek.dataset.month){ //avoids past months
					nextPrev.dataset.date = nextWeek.dataset.month;
					nextWeek.dataset.month = targetMonth;
					modifyMonth(prev,false,nextWeek);
					getEvents(targetMonth);
				}
			})
		})
		document.querySelectorAll('.js-month-next').forEach(next => {
			let nextWeek = next.previousElementSibling;
			let prevNext = nextWeek.previousElementSibling;
			next.addEventListener('click', function () {
				let targetMonth = next.dataset.date;
				prevNext.dataset.date = nextWeek.dataset.month;
				nextWeek.dataset.month = targetMonth;
				modifyMonth(next,true,nextWeek);
				getEvents(targetMonth);

			})
		})
	}

	//for Accommodations
	document.querySelectorAll('.rooms-block__tabs li').forEach((btn, i) => {
		btn.addEventListener('click', _ => {
			document.querySelectorAll('.rooms-block__tabs li').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.rooms-block__unit').forEach(room => {
				room.classList.remove('active');
				if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
					room.classList.add('active');
				}
			});
		});

		if (i === 0) btn.click();
	});


	if(document.querySelector('.specials-block')){
		let tabs = document.querySelectorAll('.specials-block__tabs li');
		let lastClick = null;

		tabs.forEach((tab)=>{
			tab.addEventListener('click',(e)=>{
				let tag = e.target.dataset.special;
				let items = document.querySelectorAll('.specials-block__item');
				if(lastClick){
					lastClick.classList.remove('active');
				}
				if(tag == 'all'){
					items.forEach((item)=>{
						item.classList.remove('hidden');
					})
				}else{
					items.forEach((item)=>{
						item.classList.toggle('hidden',item.dataset.special != tag)
					})
				}
				tab.classList.add('active');
				lastClick = tab;
			})
		})
		tabs[1].click();
	}

	//for Activities
	document.querySelectorAll('.activities-block__tabs li').forEach((btn, i) => {
		btn.addEventListener('click', _ => {
			document.querySelectorAll('.activities-block__tabs li').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.activities-block__item').forEach(room => {
				room.classList.remove('active');
				if ( btn.dataset.special === 'all' || btn.dataset.special === room.dataset.special ) {
					room.classList.add('active');
				}
			});
		});

		if (i === 1) btn.click();
	});

	document.addEventListener('DOMContentLoaded', function() {
		var learnMoreButtons = document.querySelectorAll('.learn');
		var descriptionDivs = document.querySelectorAll('.description');

		if (learnMoreButtons && descriptionDivs.length > 0) {
			learnMoreButtons.forEach(function(button) {
				button.addEventListener('click', function() {
					var clickedTag = this.getAttribute('data-description');
		
					descriptionDivs.forEach(function(description) {
						description.classList.remove('active');
					});
		
					var correspondingDescription = document.querySelector('.description[data-description="' + clickedTag + '"]');
					if (correspondingDescription) {
						correspondingDescription.classList.add('active');
					}
				});
			});
	
			var closeButtons = document.querySelectorAll('.description .close');
			closeButtons.forEach(function(closeButton) {
				closeButton.addEventListener('click', function() {
					var parentDescription = this.parentElement;
	
					if (parentDescription.classList.contains('active')) {
						parentDescription.classList.remove('active');
					}
				});
			});
		}
	});

	document.addEventListener('DOMContentLoaded', function() {
		var learnMoreButtons = document.querySelectorAll('.js-form');
		var descriptionDivs = document.querySelectorAll('.form-quad__form');

		if (learnMoreButtons && descriptionDivs.length > 0) {
			learnMoreButtons.forEach(function(button) {
				button.addEventListener('click', function() {
					var clickedTag = this.getAttribute('data-form');
		
					descriptionDivs.forEach(function(description) {
						description.classList.remove('active');
					});
		
					var correspondingDescription = document.querySelector('.form-quad__form[data-form="' + clickedTag + '"]');
					if (correspondingDescription) {
						correspondingDescription.classList.add('active');
					}
				});
			});
	
			var closeButtons = document.querySelectorAll('.form-quad__form .close');
			closeButtons.forEach(function(closeButton) {
				closeButton.addEventListener('click', function() {
					var parentDescription = this.parentElement;
	
					if (parentDescription.classList.contains('active')) {
						parentDescription.classList.remove('active');
					}
				});
			});
		}
	});

	//for Menus
	document.querySelectorAll('.menu-restaurant__tabs li').forEach((btn, i) => {
		btn.addEventListener('click', _ => {
			document.querySelectorAll('.menu-restaurant__tabs li').forEach(b => b.classList.remove('active'));
			btn.classList.add('active');

			document.querySelectorAll('.menu-restaurant__container--content').forEach(room => {
				room.classList.remove('active');
				if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
					room.classList.add('active');
				}
			});
		});

	if (i === 0) btn.click();
	});

	var privacyPolicyLinks = document.querySelectorAll('a[href="/privacy-policy"]');
    privacyPolicyLinks.forEach(function(link) {
        link.removeAttribute('target');
    });


	//Header Images
	document.addEventListener('DOMContentLoaded', function() {
		if(window.innerWidth > 600){
			var menuImages = document.querySelectorAll('.menu-images img');
		
			if (menuImages.length > 0) {
				menuImages.forEach(function(img) {
					var claseEspecifica = img.className; // Obtener la clase específica de cada imagen
					var specificImage = document.querySelector('img.' + claseEspecifica);
					var privaryNavigationItem = document.querySelector('.privary-navigation__item a.' + claseEspecifica);
					
					if (specificImage && privaryNavigationItem) {
						privaryNavigationItem.appendChild(specificImage.cloneNode(true)); // Clonar la imagen para moverla
						specificImage.remove(); // Eliminar la imagen original si se movió correctamente
					}
				});
			}
		}
	});

	//Header Element
	document.addEventListener('DOMContentLoaded', function() {
		var privacyNavigationItems = document.querySelectorAll('#privary-navigation li');
	
		privacyNavigationItems.forEach(function(item) {
			var nestedUl = item.querySelector('ul');
			
			if (nestedUl) {
				item.addEventListener('mouseover', function() {
					var privacyNavigation = document.querySelector('#privary-navigation');
					privacyNavigation.classList.add('active');
				});
	
				item.addEventListener('mouseout', function() {
					var privacyNavigation = document.querySelector('#privary-navigation');
					privacyNavigation.classList.remove('active');
				});
			}
		});
	});

	//For Mobile Navigation
	/*MOBILE MENU NAV
	****************************************************************/
    let MenuBtn = document.querySelector('.js-open-menu');
    let CloseMenu = document.querySelector('.close-menu');
    let Navigation = document.querySelectorAll('.header__mobile');
    let NavUl = document.querySelectorAll('.navigation .inner ul li');
    let NavA = document.querySelectorAll('.navigation .inner ul li a');
    let NavActive = document.querySelectorAll('.navigation ul.submenu li .active');

    //Open Navigation
    if(MenuBtn){
        MenuBtn.addEventListener('click', function(e){
            Navigation[0].classList.add('active');
            NavUl.forEach(function(inner) {
                if(inner.classList.contains('item-open')){
                    inner.scrollIntoView(false);
                }
            });
        });

        // Sub-Navigation
        // Open active sub-nav on load
        NavActive.forEach(function(inner) {
            inner.closest('.inner').classList.add('open');
            inner.parentNode.parentNode.parentNode.parentNode.classList.add('item-open');
			document.querySelector('.item-open > a').classList.add('active');
            inner.closest('.sub-sub-menu').classList.add('menu-open');;
        });

        //Toggle open/close on tap
        NavA.forEach(function(entry) {
            if(entry.nextElementSibling){
                let clientHeight = entry.nextElementSibling.querySelector('.submenu').clientHeight;
                if(entry.classList.contains('active') || entry.classList.contains('parent-active')){
                    entry.nextElementSibling.classList.add('menu-open');
                    entry.nextElementSibling.style.height = clientHeight+'px';
                }
                entry.addEventListener('click', function(e){
                    if(this.nextElementSibling.classList.contains('menu-open')){
                        this.nextElementSibling.classList.remove('menu-open');
                        this.nextElementSibling.style.height = '0px';
                    } else {
                        NavUl.forEach(function(ul) {
                            if(ul.querySelector('.sub-sub-menu')){
                                if(ul.querySelector('.sub-sub-menu').classList.contains('menu-open')){
                                    ul.querySelector('.sub-sub-menu').style.height = '0px';
                                    ul.querySelector('.sub-sub-menu').classList.remove('menu-open');
                                }
                            }
                        });
                        this.nextElementSibling.classList.add('menu-open');
                        this.nextElementSibling.style.height = clientHeight+'px';
                    }
                });
            }
        });
    }

    //Close Navigation
    if(CloseMenu){
        CloseMenu.addEventListener('click', function(e){
            Navigation[0].classList.remove('active');
        });
    }


	

	document.addEventListener('DOMContentLoaded', function() {
		var select = document.getElementById('suites-tabs');
		var suitesItems = document.querySelectorAll('.suites__item');

		if (select && suitesItems.length > 0) {
			suitesItems[0].classList.add('active');
		
			select.addEventListener('change', function() {
				var selectedValue = select.value;
		
				suitesItems.forEach(function(item) {
					var dataTag = item.getAttribute('data-tag');
					
					if (dataTag === selectedValue) {
						item.classList.add('active');
					} else {
						item.classList.remove('active');
					}
				});
			});
		}
	});

	document.addEventListener('DOMContentLoaded', function() {
		var select = document.getElementById('menu-tabs');
		var suitesItems = document.querySelectorAll('.menu-restaurant__container--content');

		if (select && suitesItems.length > 0) {
			suitesItems[0].classList.add('active');
		
			select.addEventListener('change', function() {
				var selectedValue = select.value;
		
				suitesItems.forEach(function(item) {
					var dataTag = item.getAttribute('data-tag');
					
					if (dataTag === selectedValue) {
						item.classList.add('active');
					} else {
						item.classList.remove('active');
					}
				});
			});
		}
	});


	document.addEventListener('DOMContentLoaded', function() {
		var select = document.getElementById('dining-tabs');
		var diningItems = document.querySelectorAll('.dining-quad__item');

		if (select && diningItems.length > 0) {
			diningItems[0].classList.add('active');
		
			select.addEventListener('change', function() {
				var selectedValue = select.value;
		
				diningItems.forEach(function(item) {
					var dataTag = item.getAttribute('data-tag');
					
					if (dataTag === selectedValue) {
						item.classList.add('active');
					} else {
						item.classList.remove('active');
					}
				});
			});
		}
	});

	var pinItems = document.querySelectorAll(".pin-item");
	if (pinItems.length>0) {
        pinItems.forEach(function (pinItem) {
            var icon = pinItem.querySelector(".icon");
            var lightboxContent = pinItem.querySelector(".lightbox-content");
            
            icon.addEventListener("click", function () {
                document.querySelectorAll(".lightbox-content.active").forEach(function (otherLightbox) {
                    otherLightbox.classList.remove("active");
                });
                document.querySelectorAll(".icon.active").forEach(function (otherLightbox) {
                    otherLightbox.classList.remove("active");
                });
                
                lightboxContent.classList.toggle("active");
                icon.classList.toggle("active");
            });
        });
	}

	/*****************************************************
	OBSERVER TO ADD PARALLAX EFFECT
	/*****************************************************/
	var scrollParallax = [];
	var scrolled = 0;
	
	// screen height
	var v_height =
	window.innerHeight ||
	document.documentElement.clientHeight ||
	document.body.clientHeight;
	
	function doParallax(elm) {
		let boundes = elm.dataset.parallax.split(","); // get it from html
		//get distance in positive value
		let distance = Math.abs(boundes[0] - boundes[1]);
		if (boundes[0] > boundes[1]) {
			//get distance in negative value (to do the scroll inverse)
			distance = distance * -1;
		}
		//Equivalent distance using screen height + element height
		const unit_scroll = distance / (v_height + elm.offsetHeight);
		let temp = 0;
		
		let topElement = 0;
		let element = elm;
		
		let id_elem = elm.dataset.parallaxid;
		
		do {
			topElement += element.offsetTop || 0;
			element = element.offsetParent;
		} while (element);
		
		let parallaxFunction = function () {
			//Obtain the distance between top screen and document top 0
			scrolled = document.documentElement.scrollTop || window.pageYOffset;
			//Distance of bottom page to top of the element
			let relative_distance = scrolled + v_height - topElement;
			//transpoling data to move the parallax element relative to the scroll of all the screen
			temp = unit_scroll * relative_distance + parseInt(boundes[0]);
			//console.log('scroll: '+scrolled+' v_height: '+v_height+' element top: '+elm.offsetTop)
			elm.setAttribute("style", "transform: translate(0, " + temp + "px)");
		};
		
		scrollParallax[id_elem] = parallaxFunction;
		
		window.addEventListener("scroll", scrollParallax[id_elem]);
		}
		
		let observers_parallax = document.querySelectorAll(".js-parallax-element");
		
		if (observers_parallax) {
		let options_parallax = {
			root: null, // relative to document viewport
			rootMargin: "0px", // margin around root. Values are similar to css property. Unitless values not allowed
			threshold: 0, // visible amount of item shown in relation to root
		};
		
		function handler_parallax(entries, observer) {
			let entry;
			entries.forEach(function (entry) {
			if (entry.isIntersecting) {
				doParallax(entry.target);
			} else {
				let id_elem = entry.target.dataset.parallaxid;
				window.removeEventListener("scroll", scrollParallax[id_elem]);
			}
			});
		}
		
		let observable_parallax = new IntersectionObserver(
			handler_parallax,
			options_parallax
		);
		let counter = 1;
		observers_parallax.forEach(function (element) {
			observable_parallax.observe(element);
			element.dataset.parallaxid = counter;
			counter++;
		});
	}

	var data = document.URL;

	if(data.indexOf("?filter") != -1 && document.querySelector('.rooms-block')){
		let dataFilter = data.split('?filter=')[1];
		document.querySelector('[data-tag="'+dataFilter+'"]').click();
		let target = document.querySelector('.rooms-block__title');
		let headerHeight = document.querySelector('header').offsetHeight + 50;

		window.scrollTo({
			top: target.offsetTop - headerHeight,
			behavior: 'smooth'
		});
	}

})();

function modifyMonth(el,add,nextWeek){
	let currentTarget = el.dataset.date.split('-');
	let dateConvert = new Date(currentTarget[1],parseInt(currentTarget[0]) - 1, 1);
	nextWeek.innerHTML = dateConvert.toLocaleString('default', { month: 'long' }) + ', ' + dateConvert.getFullYear();
	if(add){
		dateConvert.setMonth(dateConvert.getMonth() + 1);
	} else {
		dateConvert.setMonth(dateConvert.getMonth() - 1);
	}

	let finalMonth = (dateConvert.getMonth() + 1)  < 10 ? '0' + (dateConvert.getMonth() + 1) : (dateConvert.getMonth() + 1) ;
	el.dataset.date = finalMonth + '-' +dateConvert.getFullYear();
	
}

function modifyDate(date, days, add) {
	let newDate;

	if (add) {
		newDate = new Date(date.getTime() + days * (24 * 60 * 60 * 1000));
	} else {
		newDate = new Date(date.getTime() - days * (24 * 60 * 60 * 1000));
	}

	let month = parseInt(newDate.getMonth()) + 1 < 10 ? '0' + (newDate.getMonth() + 1) : newDate.getMonth() + 1;
	let day = parseInt(newDate.getDate()) < 10 ? '0' + newDate.getDate() : newDate.getDate();

	return newDate.getFullYear() + '/' + month + '/' + day;
}
function setSibling(prev,next,week) {
	let weekHTML = '';
	let minDate = prev.dataset.min.split('/');
	let minDateConverted = new Date(minDate[0],parseInt(minDate[1]) - 1,minDate[2]);
	let maxDate = next.dataset.max.split('/');
	let maxDateConverted = new Date(maxDate[0],parseInt(maxDate[1]) - 1,maxDate[2]);

	if(minDate[1] === maxDate[1]){
		weekHTML = minDateConverted.toLocaleString('default', { month: 'long' }) + ' ' + minDate[2] + ' - ' + maxDate[2] + ', ' + minDate[0];
	} else {
		weekHTML = minDateConverted.toLocaleString('default', { month: 'long' }) + ' ' + minDate[2] + (minDate[0] === maxDate[0] ? '':', ' + minDate[0]) + ' - ' + maxDateConverted.toLocaleString('default', { month: 'long' }) + ' ' + maxDate[2] + ', ' + maxDate[0];
	}
	week.innerHTML = weekHTML;
}
function setRealDate(currentDate) {
	let newDate = new Date(currentDate);
	newDate.setHours(0, 0, 0, 0);
	return newDate;
}



function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 60){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function interactiveMapMobile(){
	console.log(1);
	const interactiveMapsMobile = document.querySelectorAll('.map-interactive');

	interactiveMapsMobile.forEach( map => {
		
		let titleToOpenAccordion = map.querySelectorAll('.title'),
			namePointOnAccordion = map.querySelectorAll('ul li');

		titleToOpenAccordion.forEach( triggerAccordion => {
			triggerAccordion.addEventListener( 'click', () => {	
				let accordion = triggerAccordion.parentElement;

				map.querySelectorAll('.list').forEach( element => {
					if( element != accordion){ 
						element.classList.remove('open')  
					}
				} )

				if( !accordion.classList.contains('open') )
					accordion.classList.add('open')
				else
					accordion.classList.remove('open')
			} )
		} )

		namePointOnAccordion.forEach( triggerNameOnList => {
			triggerNameOnList.addEventListener( 'click', () => {
				let stringNameClicked = triggerNameOnList.textContent.split('. ')[1];
				stringNameClicked = stringNameClicked.toLowerCase();
				stringNameClicked = stringNameClicked.replaceAll(' ', '_');
				
				let markerOnMap = map.querySelector(`.pin-item[data-pin_name="${stringNameClicked}"]`);
				if( markerOnMap ){
					document.querySelectorAll('.pin-item').forEach( pin => { 
						if( !pin.classList.contains('hidden') ){
							pin.classList.add('hidden')
						}
					 } )
					markerOnMap.classList.remove('hidden')
					markerOnMap.querySelector('.icon').click()
				}
			} )
		} )

	} )
}